import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { useSession } from '@sdk/session/SessionContext';

import {
  flattenMentionIdsByType,
  getEmptyMentionsDict,
  isMentionable,
} from './useMentionPersonas.utils';

export const useMentionPersonas = (memberIds: number[]) => {
  const { currentUser } = useSession();
  const { users, personasDict } = usePersonaCollection();

  return useMemo(() => {
    const initialDict = getEmptyMentionsDict();
    const dictKeys = Object.keys(initialDict);
    const mentionIdsByType = Object.keys(personasDict).reduce((mentionsDict, id) => {
      const persona = personasDict[Number(id)];

      const validPersona = persona && persona.id !== currentUser.id;

      if (
        validPersona &&
        dictKeys.includes(persona.type) &&
        isMentionable(persona, memberIds, users)
      ) {
        mentionsDict[persona.type].push(persona.id);
      }

      return mentionsDict;
    }, initialDict);

    return flattenMentionIdsByType(personasDict, dictKeys, mentionIdsByType);
  }, [currentUser, memberIds, personasDict, users]);
};
